export class ImageModel {
    public UrlFullSize: string;
    public UrlThumbnail: string;
    public Numero: number;
    public Descrizione: string;
    public Default: boolean;
    public Internet: boolean;
    public VirtualTour: boolean;

    constructor(data: any) {

        if (data) {

            for (let property in data)
                this[property] = data[property];

            /* for (let property in data)
            {
                if (this.hasOwnProperty(property))
                    this[property] = data[property];
            } */
        }
    }
}


// WEBPACK FOOTER //
// ./src/models/image.model.ts